var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    {
      attrs: {
        title: _vm.activateSpinner ? "" : _vm.$t("Webheader.company"),
        "show-filter": true,
        "show-refresh": true,
        "show-extract": true,
        "filter-expanded": _vm.displayFilter,
        "refresh-disabled": _vm.activateSpinner,
        "extract-disabled": _vm.activateSpinner,
      },
      on: {
        "toggle-filter": _vm.toggleFilter,
        refresh: _vm.refreshInbox,
        extract: _vm.exportCompany,
      },
    },
    [
      _c("template", { slot: "secondaryActions" }, [
        _c(
          "div",
          [
            _c(
              "b-collapse",
              {
                staticClass: "mt-3",
                model: {
                  value: _vm.displayFilter,
                  callback: function ($$v) {
                    _vm.displayFilter = $$v
                  },
                  expression: "displayFilter",
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "bg-white border rounded p-3" },
                  [
                    _c(
                      "b-row",
                      { staticClass: "g-3 mb-3" },
                      [
                        _c("b-col", { attrs: { sm: "6", lg: "4" } }, [
                          _c(
                            "div",
                            { staticClass: "bg-light border rounded p-3" },
                            [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "form-label font-weight-bold text-muted mb-2",
                                  attrs: { for: "filter-active" },
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa-solid fa-toggle-on mr-2",
                                  }),
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.$t("administration.active")) +
                                      "\n                "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.active,
                                      expression: "active",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    id: "filter-active",
                                    "aria-label":
                                      _vm.$t("filter.search_by") +
                                      " " +
                                      _vm.$t("administration.active"),
                                  },
                                  on: {
                                    input: _vm.delayApplyFilter,
                                    change: function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.active = $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    },
                                  },
                                },
                                [
                                  _c("option", { attrs: { value: "" } }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("administration.select_activity")
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "0" } }, [
                                    _vm._v(_vm._s(_vm.$t("administration.no"))),
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "1" } }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("administration.in_prgrss"))
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "2" } }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("administration.yes"))
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("b-col", { attrs: { sm: "6", lg: "4" } }, [
                          _c(
                            "div",
                            { staticClass: "bg-light border rounded p-3" },
                            [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "form-label font-weight-bold text-muted mb-2",
                                  attrs: { for: "filter-identifier" },
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa-solid fa-id-card mr-2",
                                  }),
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.$t("administration.user_login")
                                      ) +
                                      "\n                "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.identifier,
                                    expression: "identifier",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  id: "filter-identifier",
                                  type: "text",
                                  placeholder: _vm.$t(
                                    "administration.enter_id"
                                  ),
                                  "aria-label":
                                    _vm.$t("filter.search_by") +
                                    " " +
                                    _vm.$t("administration.user_login"),
                                },
                                domProps: { value: _vm.identifier },
                                on: {
                                  input: [
                                    function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.identifier = $event.target.value
                                    },
                                    _vm.delayApplyFilter,
                                  ],
                                },
                              }),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("b-col", { attrs: { sm: "6", lg: "4" } }, [
                          _c(
                            "div",
                            { staticClass: "bg-light border rounded p-3" },
                            [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "form-label font-weight-bold text-muted mb-2",
                                  attrs: { for: "filter-name" },
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa-solid fa-building mr-2",
                                  }),
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.$t("administration.user")) +
                                      "\n                "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.name,
                                    expression: "name",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  id: "filter-name",
                                  type: "text",
                                  placeholder: _vm.$t(
                                    "administration.enter_company_name"
                                  ),
                                  "aria-label":
                                    _vm.$t("filter.search_by") +
                                    " " +
                                    _vm.$t("administration.user"),
                                },
                                domProps: { value: _vm.name },
                                on: {
                                  input: [
                                    function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.name = $event.target.value
                                    },
                                    _vm.delayApplyFilter,
                                  ],
                                },
                              }),
                            ]
                          ),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      { staticClass: "gx-2" },
                      [
                        _c(
                          "b-col",
                          { attrs: { cols: "6" } },
                          [
                            _c("app-button", {
                              attrs: {
                                text: _vm.$t("filter.clr_fltr_field"),
                                icon: "fa-light fa-eraser",
                                variant: "secondary",
                                outline: "",
                                block: true,
                                "aria-label": _vm.$t("filter.clr_fltr_field"),
                                disabled:
                                  !_vm.hasInputFilter || _vm.activateSpinner,
                              },
                              on: { click: _vm.clearFilterFields },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { attrs: { cols: "6" } },
                          [
                            _c("app-button", {
                              attrs: {
                                text: _vm.$t("common.srch"),
                                icon: "fa-light fa-magnifying-glass",
                                variant: "primary",
                                block: true,
                                "aria-label":
                                  _vm.$t("common.srch") +
                                  " " +
                                  _vm.$t("Webheader.company"),
                                loading: _vm.activateSpinner,
                                loadingText: _vm.$t("common.rfrsh"),
                              },
                              on: { click: _vm.applyFilter },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("template", { slot: "pageContent" }, [
        _c(
          "div",
          { staticClass: "overflow-hidden" },
          [
            _c(
              "b-row",
              { staticClass: "no-gutters" },
              [
                _c("b-col", { attrs: { md: "12" } }, [
                  _c("div", { staticClass: "requestsList" }, [
                    _c(
                      "div",
                      { staticClass: "mt-0" },
                      [
                        _vm.activateSpinner
                          ? _c("spinner")
                          : _c(
                              "div",
                              { staticClass: "overflow-x-unset" },
                              [
                                _vm.CompaniesList.length
                                  ? _c("b-table", {
                                      staticClass: "mt-3",
                                      attrs: {
                                        hover: "",
                                        items: _vm.CompaniesList,
                                        fields: _vm.companyFields,
                                        selectable:
                                          _vm.CompaniesList.length > 0,
                                        "empty-text": _vm.$t(
                                          "common.security.no_result"
                                        ),
                                      },
                                      on: {
                                        "row-selected": _vm.seeCompanyDetails,
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "cell(active)",
                                            fn: function (data) {
                                              return [
                                                data.value === "0"
                                                  ? _c("div", [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa-duotone fa-xmark btn btn-icon btn-icon-red",
                                                      }),
                                                    ])
                                                  : data.value === "1"
                                                  ? _c("div", [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa-duotone fa-warning btn btn-icon btn-icon-orange",
                                                      }),
                                                    ])
                                                  : data.value === "2"
                                                  ? _c("div", [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa-duotone fa-check btn btn-icon btn-icon-green",
                                                      }),
                                                    ])
                                                  : _vm._e(),
                                              ]
                                            },
                                          },
                                          {
                                            key: "cell(edit)",
                                            fn: function (data) {
                                              return [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "text-center d-inline-block py-4 w-100",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.activateEdit(
                                                          $event,
                                                          data.value
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa-regular fa-pencil",
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            },
                                          },
                                          {
                                            key: "cell(delete)",
                                            fn: function (data) {
                                              return [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "text-center d-inline-block py-4 w-100",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.activateDelete(
                                                          $event,
                                                          data.value
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa-light fa-trash",
                                                    }),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("span"),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        3483257926
                                      ),
                                    })
                                  : _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex justify-content-center",
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "noResult" },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.$t("common.no_result")
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                _vm._v(" "),
                                _c(
                                  "b-row",
                                  {
                                    staticClass:
                                      "justify-content-end mt-3 no-gutters",
                                  },
                                  [
                                    _vm.canUserAddCompagny
                                      ? _c(
                                          "b-button",
                                          {
                                            staticClass: "mt-3",
                                            attrs: { variant: "primary" },
                                            on: { click: _vm.addCompany },
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "fa-light fa-plus fs-17px",
                                            }),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "administration.company_add"
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                      ],
                      1
                    ),
                  ]),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }